import store from "@/store";
import { registFormEventDataLambdaInvoke } from "@/utils/LambdaHelper";
import { getUserSessionCookie } from "@/utils/Auth";

const sendEvent = async (eventType, trackingName) => {
  try {
    if (
      isSendEventData(trackingName) &&
      eventType &&
      getUserSessionCookie() &&
      store.getters.getSystemAuId
    ) {
      let eventData = {
        system_auid: store.getters.getSystemAuId,
        key: trackingName,
        event: eventType,
      };
      await registFormEventDataLambdaInvoke(eventData);
    }
  } catch (e) {
    sendErrorEvent(trackingName);
  }
};

const sendErrorEvent = async (trackingName) => {
  try {
    if (getUserSessionCookie()) {
      let eventData = {
        system_auid: store.getters.getSystemAuId,
        key: trackingName,
        event: "get_error",
      };
      await registFormEventDataLambdaInvoke(eventData);
    }
    // eslint-disable-next-line no-empty
  } catch (error) {}
};

const isSendEventData = (trackingName) => {
  const trackingEventDataSetting = store.getters.getTrackingEventDataSetting;
  if (!trackingEventDataSetting || !trackingName) {
    return false;
  }
  return trackingEventDataSetting[trackingName] === "1";
};

export const sendInputEvent = (trackingName) => {
  sendEvent("input", trackingName);
};
export const sendFocusEvent = (trackingName) => {
  sendEvent("focus", trackingName);
};
export const sendChangeEvent = (trackingName) => {
  sendEvent("change", trackingName);
};
export const sendBlurEvent = (trackingName) => {
  sendEvent("blur", trackingName);
};
export const sendClickEvent = (trackingName) => {
  sendEvent("click", trackingName);
};
export const sendMousedownEvent = (trackingName) => {
  sendEvent("mousedown", trackingName);
};
export const sendMouseoverEvent = (trackingName) => {
  sendEvent("mouseover", trackingName);
};
export const sendMouseoutEvent = (trackingName) => {
  sendEvent("mouseout", trackingName);
};
export const sendKeydownEvent = (trackingName) => {
  sendEvent("keydown", trackingName);
};
export const sendKeyupEvent = (trackingName) => {
  sendEvent("keyup", trackingName);
};
